import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Similar to swatch but presents checkbox icon instead
 */
@Component({
    selector: 'loader-1',
    template: '',
    styleUrls: ['./loader-1.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class Loader1Component {}
